// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_to-object.js
// module id = 259
// module chunks = 2